import mg from 'maplibre-gl'
import 'maplibre-gl/dist/maplibre-gl.css'
mg.setRTLTextPlugin('/public/mapbox-gl-rtl-text.min.js', true)
